import ToastModule from '..';
import strings from './strings';

export const showCloseAndClassifyErrorToast = () => {
  ToastModule.showToast({
    status: 'critical',
    title: 'Unable to close and classify call',
    toastBody:
      'Please wait and try again. If the problem persists, log an issue with support.',
  });
};

export const showCallCompletedToast = () => {
  ToastModule.showToast({
    title: strings.writeClassificationToasts.successUpsert,
    status: 'success',
    duration: 5000,
  });
};
